/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Payments_VsInputs */

const cs_deal_payments_vs = /** @type {(inputs: Deal_Payments_VsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variabilní symbol`)
};

const en_deal_payments_vs = /** @type {(inputs: Deal_Payments_VsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variable symbol`)
};

/**
* | output |
* | --- |
* | "Variable symbol" |
*
* @param {Deal_Payments_VsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_payments_vs = /** @type {((inputs?: Deal_Payments_VsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Payments_VsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_payments_vs(inputs)
	return cs_deal_payments_vs(inputs)
});